import { render, staticRenderFns } from "./OceanEngineAiData.vue?vue&type=template&id=36075c23&scoped=true&"
import script from "./OceanEngineAiData.vue?vue&type=script&lang=js&"
export * from "./OceanEngineAiData.vue?vue&type=script&lang=js&"
import style0 from "./OceanEngineAiData.vue?vue&type=style&index=0&id=36075c23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36075c23",
  null
  
)

export default component.exports